import React from "react";
import ReactDOM from "react-dom";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

import HexModal from "../../app/components/modals/HexModal";
import { showErrorMessage } from "../commons/show-error-message";
import ActionConfirmationModal from "../../app/components/modals/ActionConfirmationModal";
import { rejectEducation } from "./reject-education";
import { hideModal } from "../commons/hide-modal";

function renderRejectHHRRRequest({ requestId }) {
  const target = document.getElementById("table-request-education-container");
  if (target) {
    ReactDOM.render(
      <HexModal>
        <ActionConfirmationModal
          message="¿Estás seguro de que quieres denegar este curso?"
          actionName="Denegar solicitud"
          isWarning
          cantBeReverted
          callback={() => {
            rejectEducation(requestId);
            hideModal();
          }}
        />
      </HexModal>,
      document.getElementById("modal-container")
    );
  }
}

export async function displayRejectHHRRRequest(requestId, amount) {
  try {
    renderRejectHHRRRequest({ requestId, amount });
    addContextLog("info", "displayRejectHHRRRequest", "display-screen", {
      requestId,
      amount,
    });
  } catch (e) {
    logError(e, `Error to displayRejectHHRRRequest in request ${requestId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
